
import '../assets/styles/header.css';

const Header = ({names, score}) => {

  return (
    <header>
      <div className='left gameName'>Tic Tac Toe</div>
      <div className='right score'>Ties: {score.ties}</div>
      <div className='right score'>{names.player2}: {score.player2}</div>
      <div className='right score'>{names.player1}: {score.player1}</div>
      <hr />
    </header> 
  );
}

export default Header;